import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import ProjectCreate from '@app/views/Project/Create';
import { memo } from 'react';

export default memo(
  withIfUser(ProjectCreate)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
